import { connect } from 'react-redux';
import { compose } from 'redux';
import { withMountListener, withRenderFlag } from '@beef/react';

import { Recommendations } from 'components/Recommendations';
import {
  getRecommendationCategories,
  getRecommendationTabsData,
  getRecommendationTabsIsFetching,
  getRecommendationTabsPlacement,
  getRecommendationTabsStrategyMessage,
  getRecommendationTabsStrategyName,
} from 'store/ProductDetails/recommendationTabs/selectors';
import { addRecommendedDeviceToBasket } from 'store/common/recommendations/actions';
import { SOURCES_NAMES } from 'store/common/basket/constants';
import { fetchRecommendationTabDevices } from 'store/ProductDetails/recommendationTabs/actions';
import { getIsDigineticaRecommendsAvailable } from 'store/common/settings/selectors';
import { DEFAULT_RECOMMENDATION_TAB } from 'store/ProductDetails/recommendationTabs/constants';

const mapStateToProps = (state: any) => ({
  categories: getRecommendationCategories(state),
  devices: getRecommendationTabsData(state),
  isLoading: getRecommendationTabsIsFetching(state),
  strategyName: getRecommendationTabsStrategyName(state),
  strategyMessage: getRecommendationTabsStrategyMessage(state),
  placement: getRecommendationTabsPlacement(state),
  shouldRender: getIsDigineticaRecommendsAvailable(state),
});

const mapDispatchToProps = (dispatch: any) => ({
  onMount: () => dispatch(fetchRecommendationTabDevices(DEFAULT_RECOMMENDATION_TAB)),
  onAddToBasket: (deviceId: number) =>
    dispatch(addRecommendedDeviceToBasket(deviceId, SOURCES_NAMES.PRODUCT_DETAILS_PAGE)),
  onChangeTab: (slug: string) => dispatch(fetchRecommendationTabDevices(slug)),
});

export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  withRenderFlag,
  withMountListener,
)(Recommendations);
